import type { ReactNode } from "react";
import styles from "./simplePageLayout.module.scss";

interface SimplePageLayoutProps {
  title: string;
  onSave?: () => void;
  saving?: boolean;
  children: ReactNode;
}

export function SimplePageLayout({ title, onSave, saving, children }: SimplePageLayoutProps) {
  return (
    <div className={styles.layout}>
      <div className={styles.header}>
        <h1>{title}</h1>
        {onSave && (
          <button onClick={onSave} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
